'use strict';

customerZone

    .controller('MySimController', ['$q', '$log', 'utils', 'UnleashedClient', 'Session', 'errorCode',
        'shippingInfoProvider', 'LightToFullService', 'OrderService', 'ControllerBase',
        function($q, $log, utils, api, Session, errorCode, shippingInfoProvider, LightToFullService,
                 OrderService, ControllerBase){

            var self = this;
            ControllerBase.call(this, utils);

            self.sim = {};
            self.msisdn = undefined;
            self.swap = {};
            self.phone = {};
            self.simLoading = false;
            self.swapLoading = false;
            self.notApplicable = false;
            self.swapAllowed = true;

            self.migrating = false;

            self.today = moment();

            // This will be set by handleValidationErrors
            self.uwaValidationErrors = {};

            self.isSimSelfBlocked = function(){
                return self.sim.state === 'user_blocked';
            };

            self.getSimBlockState = function(){
                return (self.sim.state === 'user_blocked' || self.sim.state === 'admin_blocked') ? 'blocked' : 'active';
            };

            var getSimInfo = function(){
                self.simLoading = true;
                Session.refresh().then(
                    function (response) {
                        self.sim = Session.subscriber().sim || {};
                        self.msisdn = Session.subscriber().msisdn;
                        self.simLoading = false;
                    },
                    function (error) {
                        $log.error('failed to fetch sim state: ', error);
                        self.simLoading = false;
                        utils.showError();
                    }
                );
            };

            self.toggleSimBlock = function() {
                var action = self.isSimSelfBlocked() ? false : true;
                var msisdn = self.msisdn.substring(0, 1) === '+' ? self.msisdn.substring(1) : self.msisdn;
                var donePromise = api.simBlockSwitch(msisdn, action)
                    .then(getSimInfo)
                    .catch(function(error){
                        if (errorCode.is(error, errorCode.OTHER_PENDING_PROCESS)) {
                            busy.showError('unable_to_block_or_unblock');
                        }
                        throw error; // should be thrown for busy to catch it
                    });
                var resultMessage = (action) ? 'sim_blocked' : 'sim_unblocked';
                var busy = utils.showBusy(donePromise, 'updating_sim_state', resultMessage);
                return busy.wrappedPromise;
            };

            var getSimSwapInfo = function() {
                if (Session.subscriber().state !== jim.SubscriberState.enabled){
                    self.swapAllowed = false;
                    return;
                }
                self.swapLoading = true;
                getSwapState(Session.subscriber().id).then(
                    function(swapState){
                        self.swapLoading = false;
                        if (swapState) {
                            self.swap.requested = true;
                            self.swap.date = swapState.dateCreated;
                            self.swap.processId = swapState.id;
                            self.swap.requiresActivation =
                                swapState.state === jim.OrderState.waiting_for_sim_matching ||
                                swapState.state === jim.OrderState.waiting_for_sim_activation_request;
                        }
                        else {
                            self.swap.requested = false;
                            return loadDefaultSwapAddress();
                        }
                    }).catch(function(error){
                        utils.showError();
                        $log.error(error);
                    });
            };

            var getSwapState = function(){
                return OrderService.getAllOrdersOfType(jim.OrderType.ORDER_A_SWAP)
                    .then(function(swapOrders){
                        if (swapOrders.length === 0) return undefined;
                        return swapOrders.sort(byDate)[0];
                    });

                function byDate(a, b){
                    return a.dateUpdated.isBefore(b.dateUpdated) ? 1:-1;
                }
            };

            var loadDefaultSwapAddress = function(){
                return shippingInfoProvider.getDefaultShippingAddress()
                    .then(function(shippingInfo){
                        self.swap.firstName = shippingInfo.firstName;
                        self.swap.lastName = shippingInfo.lastName;
                        self.swap.company = shippingInfo.company;
                        self.swap.address = shippingInfo.address;
                    });
            };

            self.requestSimSwap = function(){
                var simSwapPromise = api.requestSimSwap(Session.subscriber().id, self.swap.reason, self.swap.password,
                    self.swap.address, self.swap.firstName, self.swap.lastName, self.swap.company)
                    .then(function(swapState){
                        if (swapState.paymentUrl){
                            busy.freeze();
                            utils.redirect(swapState.paymentUrl);
                        }
                        self.swap.address = swapState.shipmentInfo.address;
                        getSimInfo();
                        self.swap.requested = true;
                        self.swap.processId = swapState.id;
                        self.swap.date = moment();
                    }
                    ).catch(function(error){
                        if (errorCode.is(error, errorCode.INVALID_CREDENTIALS)) {
                            utils.showError('incorrect_password');
                            busy.cancel();
                        }
                        else if (errorCode.is(error, errorCode.SWAP_ALREADY_RUNNING)) {
                            utils.showError('already_in_process');
                            busy.cancel();
                        }
                        else {
                            throw error;
                        }
                    });

                var busy = utils.showBusy(simSwapPromise, 'requesting_sim_swap', 'sim_swap_requested');
            };

            var preventNewOrderIfMigratingLightToFull = function(){
                LightToFullService.isMigrating().then(
                    function(migrating){
                        if (migrating) {
                            $log.debug('User is migrating from light to full');
                            self.migrating = true;
                        }
                        else {
                            $log.debug('User is NOT migrating from light to full');
                        }
                    }
                ).catch(function(error){
                    $log.error('Checking if the user is switching from light to full failed on the sim settings page',
                        error);
                });
            };

            if (!Session.subscriber()) {
                self.notApplicable = true;
            }
            else {
                getSimInfo();
                preventNewOrderIfMigratingLightToFull();
                getSimSwapInfo();
            }

        }]);

